exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Qgb3bqNhHzm7o{margin:16px 0 8px}._3Qgb3bqNhHzm7o:first-child{margin-top:8px}._2bGBCiMKBPdxf4{min-height:20px;position:relative;color:#6b778c;font-size:12px;font-weight:500;letter-spacing:.04em;line-height:16px;margin-top:16px;text-transform:uppercase;line-height:19px}._3Enu_cqb5zKu39,.wO4k99QQ8hFxPu{display:inline-block;height:20px;margin-right:4px;width:20px}.wO4k99QQ8hFxPu{background-size:cover;vertical-align:bottom}._2KUQ7Vq2lZvFvC{color:#6b778c}._2KUQ7Vq2lZvFvC:hover,._2KUQ7Vq2lZvFvC:hover span{color:#172b4d}._3g3NzpjsZpAz3T{margin-left:4px}._1zSirYiy7WtXHI{background-color:transparent;border-radius:3px;margin:0;padding:6px 5px 6px 6px;background:transparent;outline:none;cursor:pointer}._1zSirYiy7WtXHI,._1zSirYiy7WtXHI:hover{box-shadow:none;color:#172b4d;border:none}._1zSirYiy7WtXHI:hover{background-color:transparent;background-color:rgba(9,30,66,.13)}._1zSirYiy7WtXHI:active{background-color:transparent;border:none;box-shadow:none;background-color:rgba(9,30,66,.25);color:#172b4d}._1kM-wNx3Gdr947{display:block;margin-top:8px;margin-bottom:4px}._1wZi051xrr09CM{display:none}", ""]);

// exports
exports.locals = {
	"collapsible": "_3Qgb3bqNhHzm7o",
	"header": "_2bGBCiMKBPdxf4",
	"avatar": "wO4k99QQ8hFxPu",
	"icon": "_3Enu_cqb5zKu39",
	"headerLink": "_2KUQ7Vq2lZvFvC",
	"premiumIcon": "_3g3NzpjsZpAz3T",
	"toggle": "_1zSirYiy7WtXHI",
	"open": "_1kM-wNx3Gdr947",
	"closed": "_1wZi051xrr09CM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/collapsible/collapsible.less
// module id = Zefw
// module chunks = 24